import { Box } from '@pets-ui/Box/Box'
import { colors } from '@pets-ui/tokens/colors.stylex'

interface TimeBoxProps {
  children: React.ReactNode
  backgroundColor?: string
}

export const TimeBox = (props: TimeBoxProps) => {
  const { children, backgroundColor = colors.grey800 } = props
  return (
    <Box
      backgroundColor={backgroundColor}
      p={0.5}
      width={20}
      height={20}
      borderRadius={4}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {children}
    </Box>
  )
}
